import { render, staticRenderFns } from "./ReinforcingFabric.vue?vue&type=template&id=a54b77ea&"
import script from "./ReinforcingFabric.vue?vue&type=script&lang=js&"
export * from "./ReinforcingFabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports